<template>
  <div class="page-content">
    <nav class="page-breadcrumb" id="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">{{ breadcrumbA }}</li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ breadcrumbB }}
        </li>
      </ol>
    </nav>

    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">{{ breadcrumbB }}</h6>
            <div class="d-flex align-items-center">
              <p class="card-description w-75 p-0 m-0">
              {{ descripcion }}
              </p>
              <button v-if="isEditor('Orientacion')==true" class="btn btn-success w-25" :disabled="load" @click="nuevoTicket()">{{ load ? 'Cargando...' : 'Nueva asignacion' }}</button>
              <button v-else type="button" class="btn btn-secondary btn-xs" disabled>Nueva asignacion</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    


   <lista-carga v-show="load"></lista-carga>
   <div v-if="loadError && !load" class="alert alert-warning" role="alert">
     {{ loadError }}
     <button type="button" class="btn btn-sm btn-outline-dark ml-2" @click="obtenerOrientaciones()">Reintentar</button>
   </div>
    <!-- Table -->
    <div class="row" v-show="!load">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table
                id="orientaciones"
                class="table table-theme table-row v-middle"
                data-plugin="dataTable"
              >
                <thead>
                  <tr>
                    <th><span class="text-muted">Estado</span></th>
                    <th><span class="text-muted">Fecha</span></th>
                    <th><span class="text-muted">Nombre</span></th>
                    <th><span class="text-muted">legajo</span></th>
                    <th><span class="text-muted">Tipo licencia</span></th>
                    <th><span class="text-muted">Inicio licencia</span></th>
                    <th><span class="text-muted">Vigencia</span></th>
                    <th><span class="text-muted">Total dias</span></th>
                    <th><span class="text-muted">Restan</span></th>
                    <th><span class="text-muted">Diagnostico</span></th>
                    <th><span class="text-muted">Detalle</span></th>
                    
                    <th><span class="text-muted">Editar</span></th>
                    <th><span class="text-muted">Operacion</span></th>
                    <th><span class="text-muted">Categoria</span></th>
                    <th><span class="text-muted">Sector</span></th>
                    <th><span class="text-muted">Zonal</span></th>
                    <th><span class="text-muted">Tipo de accidente</span></th>
                    <th><span class="text-muted">Plan de accion</span></th>
                    <th><span class="text-muted">Responsable</span></th>
                    <th><span class="text-muted">Datos adjuntos</span></th>
                    <th><span class="text-muted">Acción</span></th>
                    
                   
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="(caso, k) in orientaciones" :key="k" :class="{'fila-no-distribuido':caso.hoy<1}">
                        <td>
                            <span
                              class="badge text-uppercase"
                              :class="{

                                  'badge-danger': (caso.status == 'ABIERTO'),
                                 
                                  'badge-success': (caso.status == 'CERRADO'),

                                   'badge-info': (caso.status == 'RECHAZADO')
                              }"
                            >
                              {{caso.status}}
                            </span>
                        </td>

                         <td class="text-center">{{caso.fecha}}</td>

                         <td>{{caso.nombre}}</td>

                         <td class="text-center">{{caso.legajo}}</td>

                         <td class="text-uppercase">{{caso.tipo}}</td>

                         <td>{{caso.fechaInicioLicencia}}</td>

                         <td>{{caso.vigencia}}</td>

                         <td>{{caso.dias}}</td>
                         <td>{{caso.hoy}}</td>

                         <td>{{caso.detalle}}</td>
                          <td>{{caso.diagnostico}}</td>

                         <td>
                            <select v-if="isEditor('Orientacion')==true" class="custom-select mr-3 resolucionSelect" @change="editar($event, caso)" id="accion">
                                <option value="0">Selecciona una accion</option>
                                
                               <option value="plan">Editar plan de accion</option>
                               <option value="vigencia">Editar fecha de vigencia</option>
                               <option value="inicio">Editar fecha de inicio</option>
                               <option value="operacion_m">Editar Operacion/Sector</option>
                            </select>

                            <select v-else class="custom-select mr-3 resolucionSelect" @change="cambiarStatus($event, caso)" disabled="true">
                                <option value="0">Selecciona una accion</option>
                                
                               <option value="plan">Editar plan de accion</option>
                               <option value="vigencia">Editar fecha de vigencia</option>
                               <option value="inicio">Editar fecha de inicio</option>
                               <option value="operacion_m">Editar Operacion/Sector</option>
                            </select>


                        </td>

                         <td>{{caso.distribucionName}}</td>

                         <td>{{caso.categoria}}</td>

                         <td>{{caso.sector}}</td>

                         <td>{{caso.zonal}}</td>

                         <td>{{caso.novedad}}</td>

                         <td>{{caso.plan}}</td>

                          <td>
                           <span
                              class="badge text-uppercase badge-info"
                              
                            >
                              {{caso.responsable}}
                            </span>
                        </td>

                         <td align="center"><a href="#" v-on:click="adjuntos(caso.fireId)" :id="'adj'+caso.fireId">+{{caso.archivos}}</a></td>

                        <td>
                            <select v-if="isEditor('Orientacion')==true" class="custom-select mr-3 resolucionSelect" @change="cambiarStatus($event, caso)">
                                <option value="ABIERTO" :selected="caso.status == 'ABIERTO'">ABIERTO</option>
                                
                                <option value="CERRADO" :selected="caso.status == 'CERRADO'">CERRADO</option>

                                <option value="RECHAZADO" :selected="caso.status == 'RECHAZADO'">RECHAZADO</option>
                            </select>

                            <select v-else class="custom-select mr-3 resolucionSelect" @change="cambiarStatus($event, caso)" disabled="true">
                                <option value="ABIERTO" :selected="caso.status == 'ABIERTO'">ABIERTO</option>
                                
                                <option value="CERRADO" :selected="caso.status == 'CERRADO'">CERRADO</option>

                                <option value="RECHAZADO" :selected="caso.status == 'RECHAZADO'">RECHAZADO</option>
                            </select>


                        </td>


                         
                        
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


<div id="archivos">
    <table width="100%">
            <tr>
                <td align="right"><div style="margin:20px;"><button id="cerrar">CERRAR</button></div></td>
            </tr>

            <tr>
                <div id="loading"></div>
                <td id="adj">
                    
                </td>
            </tr>
    </table>
</div>



<div id="plan">
    <table width="100%">
            <tr>
                <td align="right"><div style="margin:20px;"><button id="cerrarPlan">CERRAR</button></div></td>
            </tr>

            <tr>
               
                <td>
                   <div class="form-group">
                    <label for="exampleFormControlTextarea1">Escribe el plan de accion</label>
                    <textarea class="form-control" id="textoPlan" rows="3" style="height:300px;"></textarea>
                  </div>
                </td>
            </tr>

            <tr>
               
                <td>
                    <center><button class='btn-success' id="guardarPlan">GUARDAR PLAN DE ACCION</button></center>
                </td>
            </tr>
    </table>
</div>



<div id="vigencia">
    <table width="100%">
            <tr>
                <td align="right"><div style="margin:20px;"><button id="cerrarVigencia">CERRAR</button></div></td>
            </tr>

            <tr>
               
                <td>
                   <div class="form-group">
                    <label for="exampleFormControlTextarea1">Selecciona nueva fecha de fin de licencia</label>
                    <input type="date" class="form-control" id="textoVigencia">
                  </div>
                </td>
            </tr>

             <tr>
               
                <td>
                   <div class="form-group">
                    <b>Fecha actual de vigencia:</b> <span id="fechaactual"></span>
                  </div>
                </td>
            </tr>

            <tr>
               
                <td>
                    <center><button class='btn-success' id="guardarVigencia">GUARDAR NUEVA FECHA DE VIGENCIA</button></center>
                </td>
            </tr>
    </table>
</div>




<div id="inicio">
    <table width="100%">
            <tr>
                <td align="right"><div style="margin:20px;"><button id="cerrarInicio">CERRAR</button></div></td>
            </tr>

            <tr>
               
                <td>
                   <div class="form-group">
                    <label for="exampleFormControlTextarea1">Selecciona nueva fecha de inicio de licencia</label>
                    <input type="date" class="form-control" id="textoInicio">
                  </div>
                </td>
            </tr>

             <tr>
               
                <td>
                   <div class="form-group">
                    <b>Fecha actual de inicio:</b> <span id="fechaactualInicio"></span>
                  </div>
                </td>
            </tr>

            <tr>
               
                <td>
                    <center><button class='btn-success' id="guardarInicio">GUARDAR NUEVA FECHA DE INICIO</button></center>
                </td>
            </tr>
    </table>
</div>



<div id="operacion_m">
    <table width="100%">
            <tr>
                <td align="right"><div style="margin:20px;"><button id="cerrarOperaciones">CERRAR</button></div></td>
            </tr>

            <tr>
               
                <td>
                   <div class="form-group">
                    <label for="exampleFormControlTextarea1">Selecciona una nueva operacion</label>
                    <select class="form-control" id="operacion_id"></select>
                  </div>
                </td>
            </tr>

             <tr>
               
                <td>
                   <div class="form-group">
                    <b>Operacion actual:</b> <span id="operacion_actual"></span>
                  </div>
                </td>
            </tr>

            <tr>
               
                <td>
                    <center><button class='btn-success' id="guardarOperacion">GUARDAR NUEVA OPERACION/SECTOR</button></center>
                </td>
            </tr>
    </table>
</div>



  <modal-detalle 
    v-if="modalDetalle.open" 
    @cerrar-modal-detalle="refrescarOrientaciones($event)"
    :caso="modalDetalle.caso"
  ></modal-detalle>

  <modal-nuevo-ticket 
    v-if="modalNuevoTicket.open"
    @cerrar-modal-nuevo="refrescarOrientaciones($event)"
    :personal="personal"
  ></modal-nuevo-ticket>
</template>

<script>
import axios from "axios";
import $ from "jquery";

require("datatables.net");
require("datatables.net-buttons/js/buttons.colVis.js")();





require("datatables.net-buttons/js/buttons.html5.js")();
require("datatables.net-buttons/js/buttons.flash.js")();
require("datatables.net-buttons/js/buttons.print.js")();
require("../../../public/assets/css/data-table-estilos-propios.css");

import firebase from "firebase/app";
import "firebase/database";
import ModalDetalle from './ModalDetalle.vue';
import ModalNuevoTicket from './ModalNuevoTicket.vue';
import ListaCarga from '../ListaCarga.vue';
const userPermission = JSON.parse(sessionStorage.getItem('userPermisos')) || [];
const empleado = JSON.parse(sessionStorage.getItem("personal")) || {};
export default {
  components: { ModalDetalle, ModalNuevoTicket, ListaCarga },
  name: "Orientacion",
  data: () => ({
    breadcrumbA: "Inicio",
    breadcrumbB: "Asignacion Temporal",
    descripcion: "Listado de reclamos del personal, podés listar por fecha, resolver y detallar los inconvenientes",
    orientaciones: [],
    personal: [],
    distribuido:[],
    desde: null,
    hasta: null,
    modalDetalle : {
        open: false,
        caso: null,
    },
    modalNuevoTicket: {
        open: false,
    },
    load: true,
    loadError: null,
    casosById: {},
    loadSequence: 0,

  }),
  methods: {
    isEditor(modulo) {

      if (userPermission.find(record => record.ModulosAccess === modulo)) {
        var status = userPermission.find(record => record.ModulosAccess === modulo).Editor;

        return status;
      } else {

        return false;
      }
    },
    async obtenerOrientaciones() {
      const sequence = ++this.loadSequence;
      this.load = true;
      this.loadError = null;
      this.orientaciones = [];
      this.casosById = {};

      try {
        if ($.fn.dataTable.isDataTable('#orientaciones')) {
          $('#orientaciones').DataTable().clear().destroy();
          $('#orientaciones tbody').empty();
        }

        await new Promise(resolve => this.$nextTick(resolve));
        const table = this.initializeDataTable();
        const url = "https://aplicativos.firebaseio.com/asignaciontemporal.json?orderBy=%22$key%22&print=pretty";
        const response = await axios.get(url, { timeout: 20000 });

        if (sequence !== this.loadSequence) return;

        const data = response.data || {};
        const keys = Object.keys(data);
        const batchSize = 100;

        for (let startIndex = 0; startIndex < keys.length; startIndex += batchSize) {
          if (sequence !== this.loadSequence) return;

          const rowsToAdd = [];
          const endIndex = Math.min(startIndex + batchSize, keys.length);

          for (let i = startIndex; i < endIndex; i++) {
            const fireId = keys[i];
            const item = data[fireId];
            if (!item || typeof item !== 'object') continue;

            const status = item.status || "ABIERTO";
            const responsable = item.responsable || "Sin asignar";
            const fechaInicioLicencia = item.fechaInicioLicencia || '';
            const fechaFinLicencia = item.fechaFinLicencia || '';

            const inicioDate = fechaInicioLicencia ? new Date(fechaInicioLicencia + 'T00:00:00') : null;
            const finDate = fechaFinLicencia ? new Date(fechaFinLicencia + 'T00:00:00') : null;
            const dias = inicioDate && finDate && !isNaN(inicioDate) && !isNaN(finDate)
              ? Math.round((finDate - inicioDate) / 86400000)
              : '-';

            const hoyDate = new Date();
            hoyDate.setHours(0, 0, 0, 0);
            const hoy = finDate && !isNaN(finDate)
              ? Math.round((finDate - hoyDate) / 86400000)
              : '-';

            const adjuntos = Array.isArray(item.archivosAdjuntos) ? item.archivosAdjuntos.length : 0;
            const persona = (this.personal && this.personal[item.dni]) || empleado[item.dni] || {};

            const row = {
              dni: item.dni || item.legajo || '',
              nombre: item.nombre || '-',
              fireId,
              fechaInicioLicencia,
              vigencia: fechaFinLicencia,
              dias,
              hoy,
              legajo: persona.leg_numero || item.dni || item.legajo || '-',
              categoria: persona.cat_descrip || '-',
              fecha: item.fecha || '-',
              hora: item.hora || '-',
              id_novedad: null,
              novedad: item.tipoAccidente || '-',
              diagnostico: item.diagnostico || '-',
              detalle: item.detalle || '-',
              resolucion: item.resolucion || null,
              status,
              responsable,
              distribucion: item.distribucion || '',
              distribucionName: item.distribucionName || '-',
              sector: item.sector || '-',
              zonal: item.zonal || '-',
              archivos: adjuntos,
              plan: item.plan || '-',
              tipo: item.novedad || '-'
            };

            this.casosById[fireId] = row;

            const badgeClass = status === 'ABIERTO'
              ? 'badge-danger'
              : (status === 'RECHAZADO' ? 'badge-info' : 'badge-success');

            rowsToAdd.push([
              `<span class="badge text-uppercase ${badgeClass}">${this.escapeHtml(status)}</span>`,
              this.escapeHtml(row.fecha),
              this.escapeHtml(row.nombre),
              this.escapeHtml(row.legajo),
              this.escapeHtml(row.tipo),
              this.escapeHtml(row.fechaInicioLicencia),
              this.escapeHtml(row.vigencia),
              this.escapeHtml(row.dias),
              this.escapeHtml(row.hoy),
              this.escapeHtml(row.detalle),
              this.escapeHtml(row.diagnostico),
              this.getEditorSelect(row),
              this.escapeHtml(row.distribucionName),
              this.escapeHtml(row.categoria),
              this.escapeHtml(row.sector),
              this.escapeHtml(row.zonal),
              this.escapeHtml(row.novedad),
              this.escapeHtml(row.plan),
              `<span class="badge text-uppercase badge-info">${this.escapeHtml(row.responsable)}</span>`,
              `<a href="#" onclick="event.preventDefault(); window.app.$refs.currentComponent.adjuntos('${fireId}')" id="adj${fireId}">+${adjuntos}</a>`,
              this.getStatusSelect(row)
            ]);
          }

          if (rowsToAdd.length) {
            table.rows.add(rowsToAdd).draw(false);
          }

          // Cede el hilo entre lotes para que el navegador siga respondiendo.
          await new Promise(resolve => setTimeout(resolve, 0));
        }
      } catch (e) {
        console.error('Error cargando asignaciones:', e);
        this.loadError = 'No se pudieron cargar todas las asignaciones. Verificá la conexión e intentá nuevamente.';
      } finally {
        if (sequence === this.loadSequence) {
          this.load = false;
        }
      }
    },

    escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },

// Add this helper method to generate editor select HTML
getEditorSelect(caso) {
  const fireId = this.escapeHtml(caso.fireId);
  if (this.isEditor('Orientacion') === true) {
    return `<select class="custom-select mr-3 resolucionSelect" onchange="window.app.$refs.currentComponent.editarPorId(event, '${fireId}')">
      <option value="0">Selecciona una accion</option>
      <option value="plan">Editar plan de accion</option>
      <option value="vigencia">Editar fecha de vigencia</option>
      <option value="inicio">Editar fecha de inicio</option>
      <option value="operacion_m">Editar Operacion/Sector</option>
    </select>`;
  }
  return `<select class="custom-select mr-3 resolucionSelect" disabled>
    <option value="0">Selecciona una accion</option>
    <option value="plan">Editar plan de accion</option>
    <option value="vigencia">Editar fecha de vigencia</option>
    <option value="inicio">Editar fecha de inicio</option>
    <option value="operacion_m">Editar Operacion/Sector</option>
  </select>`;
},

getStatusSelect(caso) {
  const fireId = this.escapeHtml(caso.fireId);
  const disabled = this.isEditor('Orientacion') === true ? '' : 'disabled';
  return `<select class="custom-select mr-3 resolucionSelect" ${disabled} onchange="window.app.$refs.currentComponent.cambiarStatusPorId(event, '${fireId}')">
    <option value="ABIERTO" ${caso.status === 'ABIERTO' ? 'selected' : ''}>ABIERTO</option>
    <option value="CERRADO" ${caso.status === 'CERRADO' ? 'selected' : ''}>CERRADO</option>
    <option value="RECHAZADO" ${caso.status === 'RECHAZADO' ? 'selected' : ''}>RECHAZADO</option>
  </select>`;
},

editarPorId(event, fireId) {
  const caso = this.casosById[fireId];
  if (caso) this.editar(event, caso);
},

cambiarStatusPorId(event, fireId) {
  const caso = this.casosById[fireId];
  if (caso) this.cambiarStatus(event, caso);
},

// Add this method to initialize the DataTable with empty data
initializeDataTable() {
  if ($.fn.dataTable.isDataTable('#orientaciones')) {
    return $('#orientaciones').DataTable();
  }

  const table = $('#orientaciones').DataTable({
    columnDefs: [{ width: "100px", targets: 6 }],
    language: {
      // tu configuración de idioma aquí
    },
   
    scrollX: false,
    search: { regex: true },
    dom: '<"top"Bf<"clear">>rt<"bottom"lip><"clear">',
    buttons: [
      'copy', 'excel', 'csv', 'pdf',
      {
        text: 'Novedades',
        action: function (e, dt, node, config) {
          $('#filtroNovedades').toggle();
        }
      },
      {
        text: 'Tipo',
        action: function (e, dt, node, config) {
          $('#filtroTipo').toggle();
        }
      },
      {
        text: 'Responsable',
        action: function (e, dt, node, config) {
          $('#filtroResponsable').toggle();
        }
      },
      {
        text: 'Status',
        action: function (e, dt, node, config) {
          $('#filtroStatus').toggle();
        }
      }
    ],
    initComplete: function () {
      var table = this.api();
      
      table.column(0).search('ABIERTO', true, false).draw();
      
      // Crear y colocar select para Novedades
      var selectNovedades = $('<select id="filtroNovedades" class="select2" style="display:none;"><option value="">TODOS</option></select><br>')
        .appendTo('.dt-buttons')
        .on('change', function () {
          var val = $.fn.dataTable.util.escapeRegex($(this).val());
          table.column(4).search(val ? '^' + val + '$' : '', true, false).draw();
        });
      ["ART","ENFERMEDAD", "RESERVA DE PUESTO", "LICENCIA SIN SUELDO", "MATERNIDAD", "EXEDENCIA"].forEach(function(value) {
        selectNovedades.append('<option value="' + value + '">' + value + '</option>');
      });

      // Crear y colocar select para Tipo
      var selectTipo = $('<select id="filtroTipo" class="select2" style="display:none;"><option value="">TODOS</option></select><br>')
        .appendTo('.dt-buttons')
        .on('change', function () {
          var val = $.fn.dataTable.util.escapeRegex($(this).val());
          table.column(16).search(val ? '^' + val + '$' : '', true, false).draw();
        });
      ["ACCIDENTE DE TRABAJO", "IN-ITINERE", "REAGRAVACION REINGRESO","ENFERMEDAD PROFESIONAL"].forEach(function(value) {
        selectTipo.append('<option value="' + value + '">' + value + '</option>');
      });

      // Crear y colocar select para Responsable
      var selectResponsable = $('<select id="filtroResponsable" class="select2" style="display:none;"><option value="">TODOS</option></select><br>')
        .appendTo('.dt-buttons')
        .on('change', function () {
          var val = $.fn.dataTable.util.escapeRegex($(this).val());
          table.column(18).search(val ? '^' + val + '$' : '', true, false).draw();
        });
      ["GONZALO", "MARIANO", "EDGARDO", "SOL", "LEGALES"].forEach(function(value) {
        selectResponsable.append('<option value="' + value + '">' + value + '</option>');
      });

      // Crear y colocar select para Status
      var selectStatus = $('<select id="filtroStatus" class="select2" style="display:none;"><option value="">SELECCIONA UN ESTADO</option><option value="">TODOS</option></select><br>')
        .appendTo('.dt-buttons')
        .on('change', function () {
          var val = $.fn.dataTable.util.escapeRegex($(this).val());
          table.column(0).search(val ? '^' + val + '$' : '', true, false).draw();
        });
      ["ABIERTO", "CERRADO","RECHAZADO"].forEach(function(value) {
        selectStatus.append('<option value="' + value + '">' + value + '</option>');
      });
    }
  });
  
  return table;
},

    withTimeout(promise, ms = 20000, message = 'La operación demoró demasiado') {
      let timer;
      const timeout = new Promise((_, reject) => {
        timer = setTimeout(() => reject(new Error(message)), ms);
      });
      return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
    },

    nuevoTicket(){
        this.modalNuevoTicket.open = true;
    }, 
    async adjuntos(id) {
      const $panel = $("#archivos");
      const $adj = $("#adj");

      $panel.stop(true, true).slideDown();
      $adj.html("ARCHIVOS CARGADOS<hr><div class='text-muted'>Cargando...</div>");

      $("#cerrar").off('click.asignacion').on('click.asignacion', () => {
        $panel.stop(true, true).slideUp();
      });

      try {
        const ticketRef = firebase.database().ref('/asignaciontemporal/' + id);
        const snapshot = await this.withTimeout(ticketRef.once('value'), 20000, 'No se pudieron consultar los adjuntos');
        const data = snapshot.val() || {};
        const archivos = Array.isArray(data.archivosAdjuntos) ? data.archivosAdjuntos : [];

        $adj.html("ARCHIVOS CARGADOS<hr>");
        if (!archivos.length) {
          $adj.append("<div class='text-muted mb-2'>No hay archivos cargados.</div>");
        } else {
          archivos.forEach((url, index) => {
            const $link = $('<a>', {
              target: '_blank',
              rel: 'noopener noreferrer',
              href: url,
              text: 'Abrir archivo ' + (index + 1)
            });
            $adj.append($('<div class="mb-1">').append($link));
          });
        }

        $adj.append("<br>AGREGAR NUEVO ARCHIVO<hr>");
        $adj.append("<center><input type='file' class='form-control' multiple style='display:block;' id='nuevoarchivo'></center><span class='text-danger'>· Adjunta al menos un archivo</span><br>");
        $adj.append("<br><center><button class='btn btn-success' id='guardararchivo'>GUARDAR NUEVO ARCHIVO</button></center><div id='estadoAdjunto' class='text-center mt-2'></div>");

        $('#guardararchivo').off('click.asignacion').on('click.asignacion', async () => {
          const input = document.getElementById('nuevoarchivo');
          const files = input ? Array.from(input.files || []) : [];
          if (!files.length) {
            alert('Por favor, selecciona al menos un archivo.');
            return;
          }

          const $button = $('#guardararchivo');
          $button.prop('disabled', true).text('GUARDANDO...');
          $('#estadoAdjunto').html('<b>Cargando archivos...</b>');

          try {
            const uploadPromises = files.map((file, index) => {
              const safeName = String(file.name || 'archivo').replace(/[^a-zA-Z0-9._-]/g, '_');
              const storageRef = firebase.storage().ref(`asignaciones/${Date.now()}_${index}_${safeName}`);
              return this.withTimeout(
                storageRef.put(file).then(snapshot => snapshot.ref.getDownloadURL()),
                120000,
                'La carga de un archivo demoró demasiado'
              );
            });

            const newUrls = await Promise.all(uploadPromises);
            const latestSnapshot = await this.withTimeout(ticketRef.once('value'), 20000);
            const currentData = latestSnapshot.val() || {};
            const currentFiles = Array.isArray(currentData.archivosAdjuntos) ? currentData.archivosAdjuntos : [];
            const updatedFiles = currentFiles.concat(newUrls);

            await this.withTimeout(
              ticketRef.update({ archivosAdjuntos: updatedFiles }),
              20000,
              'No se pudo guardar la referencia de los archivos'
            );

            const counter = document.getElementById('adj' + id);
            if (counter) counter.textContent = '+' + updatedFiles.length;
            $('#estadoAdjunto').html('<span class="text-success">Archivos guardados correctamente.</span>');
            setTimeout(() => $panel.stop(true, true).slideUp(), 350);
          } catch (error) {
            console.error('Error al guardar adjuntos:', error);
            $('#estadoAdjunto').html('<span class="text-danger">No se pudieron guardar los archivos.</span>');
            alert('No se pudieron guardar los archivos. ' + (error.message || 'Verificá la conexión.'));
          } finally {
            $button.prop('disabled', false).text('GUARDAR NUEVO ARCHIVO');
          }
        });
      } catch (error) {
        console.error('Error al cargar adjuntos:', error);
        $adj.html("<div class='alert alert-danger'>No se pudieron cargar los adjuntos. Podés cerrar e intentar nuevamente.</div>");
      }
    },
    obtenerFechaActual(){
        return new Date().toISOString().slice(0, 10);
    },
    async obtenerPersonal() {
      const safeGet = async (url) => {
        try {
          return await axios.get(url, { timeout: 15000 });
        } catch (error) {
          console.warn('Consulta auxiliar no disponible:', url, error);
          return { data: {} };
        }
      };

      const [personalA, personalB, operaciones, sectores] = await Promise.all([
        safeGet('https://auth.foodservice.com.ar/index_dev.php?type=personal_core&empresa=1&access_token=1234567'),
        safeGet('https://auth.foodservice.com.ar/index_dev.php?type=personal_core&empresa=2&access_token=1234567'),
        safeGet('https://consumos.foodservice.com.ar/api/empresas'),
        safeGet('https://aplicativos.firebaseio.com/sectores.json?print=pretty')
      ]);

      const personalMezcla = Object.assign({}, personalA.data || {}, personalB.data || {});
      this.personal = Object.keys(personalMezcla).length ? personalMezcla : empleado;

      const operacionesSet = new Set();
      Object.values(operaciones.data || {}).forEach(val => {
        if (val && val.estado === 'ACTIVA' && val.name) operacionesSet.add(val.name);
      });
      Object.values(sectores.data || {}).forEach(val => {
        if (val && val.operacion) operacionesSet.add(val.operacion);
      });

      const $operacion = $('#operacion_id');
      $operacion.empty().append('<option value="">Seleccioná una operación</option>');
      Array.from(operacionesSet).sort().forEach(nombre => {
        $operacion.append($('<option>', { value: nombre, text: nombre }));
      });

      try {
        if ($operacion.data('select2')) $operacion.select2('destroy');
        $operacion.select2({ width: '100%' });
      } catch (e) {
        console.warn('Select2 no pudo inicializarse; se mantiene el select nativo.', e);
      }

      await this.obtenerOrientaciones();
    },

    obtenerEmpleadoConDni(dni){
        return this.personal[dni];
    },
    
    async cambiarStatus(event, caso) {
      const select = event.target;
      const nuevoStatus = select.value;
      const anterior = caso.status;
      select.disabled = true;

      try {
        await this.withTimeout(
          firebase.database().ref('asignaciontemporal/' + caso.fireId).update({ status: nuevoStatus }),
          20000,
          'No se pudo actualizar el estado'
        );
        caso.status = nuevoStatus;
        if (this.casosById[caso.fireId]) this.casosById[caso.fireId].status = nuevoStatus;
      } catch (e) {
        console.error('Error actualizando estado:', e);
        select.value = anterior;
        alert('No se pudo actualizar el estado. ' + (e.message || 'Verificá la conexión.'));
      } finally {
        select.disabled = false;
      }
    },

    editar(event, caso) {
      const accion = event.target.value;
      event.target.value = '0';
      if (!accion || accion === '0') return;

      const guardar = async ($button, cambios, onSuccess) => {
        if ($button.prop('disabled')) return;
        const textoOriginal = $button.text();
        $button.prop('disabled', true).text('GUARDANDO...');
        try {
          await this.withTimeout(
            firebase.database().ref('asignaciontemporal/' + caso.fireId).update(cambios),
            20000,
            'La modificación demoró demasiado'
          );
          onSuccess();
          await this.obtenerOrientaciones();
        } catch (e) {
          console.error('Error modificando asignación:', e);
          alert('No se pudo guardar la modificación. ' + (e.message || 'Verificá la conexión.'));
        } finally {
          $button.prop('disabled', false).text(textoOriginal);
        }
      };

      if (accion === 'plan') {
        $('#textoPlan').val(caso.plan === '-' ? '' : (caso.plan || ''));
        $('#plan').stop(true, true).slideDown();
        $('#guardarPlan').off('click.asignacion').on('click.asignacion', () => {
          const plan = String($('#textoPlan').val() || '').trim();
          guardar($('#guardarPlan'), { plan }, () => {
            caso.plan = plan || '-';
            $('#plan').stop(true, true).slideUp();
          });
        });
        $('#cerrarPlan').off('click.asignacion').on('click.asignacion', () => {
          $('#plan').stop(true, true).slideUp();
        });
        return;
      }

      if (accion === 'vigencia') {
        $('#textoVigencia').val(caso.vigencia || '');
        $('#fechaactual').text(caso.vigencia || '-');
        $('#vigencia').stop(true, true).slideDown();
        $('#guardarVigencia').off('click.asignacion').on('click.asignacion', () => {
          const nuevaFecha = $('#textoVigencia').val();
          if (!nuevaFecha) {
            alert('Seleccioná una nueva fecha de fin de licencia.');
            return;
          }
          if (caso.fechaInicioLicencia && nuevaFecha < caso.fechaInicioLicencia) {
            alert('La fecha de fin no puede ser anterior a la fecha de inicio.');
            return;
          }
          guardar($('#guardarVigencia'), { fechaFinLicencia: nuevaFecha }, () => {
            caso.vigencia = nuevaFecha;
            $('#vigencia').stop(true, true).slideUp();
          });
        });
        $('#cerrarVigencia').off('click.asignacion').on('click.asignacion', () => {
          $('#vigencia').stop(true, true).slideUp();
        });
        return;
      }

      if (accion === 'inicio') {
        $('#textoInicio').val(caso.fechaInicioLicencia || '');
        $('#fechaactualInicio').text(caso.fechaInicioLicencia || '-');
        $('#inicio').stop(true, true).slideDown();
        $('#guardarInicio').off('click.asignacion').on('click.asignacion', () => {
          const nuevaFecha = $('#textoInicio').val();
          if (!nuevaFecha) {
            alert('Seleccioná una nueva fecha de inicio de licencia.');
            return;
          }
          if (caso.vigencia && nuevaFecha > caso.vigencia) {
            alert('La fecha de inicio no puede ser posterior a la fecha de fin.');
            return;
          }
          guardar($('#guardarInicio'), { fechaInicioLicencia: nuevaFecha }, () => {
            caso.fechaInicioLicencia = nuevaFecha;
            $('#inicio').stop(true, true).slideUp();
          });
        });
        $('#cerrarInicio').off('click.asignacion').on('click.asignacion', () => {
          $('#inicio').stop(true, true).slideUp();
        });
        return;
      }

      if (accion === 'operacion_m') {
        $('#operacion_actual').text(caso.distribucionName || '-');
        $('#operacion_id').val(caso.distribucionName || '').trigger('change.select2');
        $('#operacion_m').stop(true, true).slideDown();
        $('#guardarOperacion').off('click.asignacion').on('click.asignacion', () => {
          const operacion = $('#operacion_id').val();
          if (!operacion) {
            alert('Seleccioná una operación/sector.');
            return;
          }
          guardar($('#guardarOperacion'), { distribucionName: operacion }, () => {
            caso.distribucionName = operacion;
            $('#operacion_m').stop(true, true).slideUp();
          });
        });
        $('#cerrarOperaciones').off('click.asignacion').on('click.asignacion', () => {
          $('#operacion_m').stop(true, true).slideUp();
        });
      }
    },

     cambiarResponsable(event, caso){
        firebase.database().ref('asignaciontemporal/' + caso.fireId).update({
            responsable: event.target.value,
        })
        .then(()=>{
            caso.responsable = event.target.value;
            console.log("RESPONSABLE")
        })
        .catch(e => {
            console.log(e);
        });


    },


    
    refrescarTabla(limpiar){
  if (limpiar === true && $.fn.dataTable.isDataTable('#orientaciones')) {
    $('#orientaciones').DataTable().destroy();
  }
  this.$nextTick(() => {
    this.initializeDataTable();
  });
},
    refrescarOrientaciones(seReasigno){
        this.modalNuevoTicket.open = false;
        this.modalDetalle.open = false;
        if (seReasigno === true) this.obtenerOrientaciones();
    },
    abrirModalDetalle(caso){
        this.modalDetalle.open = true;
        this.modalDetalle.caso = caso;
    },
    
  },
  mounted() {
    window.app = window.app || {};
    window.app.$refs = window.app.$refs || {};
    window.app.$refs.currentComponent = this;

    this.obtenerPersonal().catch(async (error) => {
      console.error('Error inicializando asignaciones:', error);
      this.personal = empleado;
      this.loadError = 'Algunos datos auxiliares no pudieron cargarse. Se muestran las asignaciones disponibles.';
      await this.obtenerOrientaciones();
    });
  },
  beforeUnmount() {
    $('#guardarPlan, #guardarVigencia, #guardarInicio, #guardarOperacion, #guardararchivo, #cerrar, #cerrarPlan, #cerrarVigencia, #cerrarInicio, #cerrarOperaciones').off('.asignacion');
    if (window.app && window.app.$refs && window.app.$refs.currentComponent === this) {
      window.app.$refs.currentComponent = null;
    }
  }
}
</script>

<style scoped>
.form-control {
    display: inline-block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    font-size: .8rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    vertical-align: middle;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    appearance: none;
}

.custom-select {
    font-size: 0.7rem;
    padding: .2rem 1.2rem .2rem .2rem;
}

.resolucionSelect {
    min-width: max-content;
}

.badge {
    margin-bottom: 0;
    font-size: 0.6rem;
    font-weight: bold;
}

.table .custom {
    word-wrap: break-word; /* Asegura que las palabras largas se rompan y pasen a la siguiente línea */
    white-space: normal; /* Permite que el texto ocupe más de una línea */
}


#archivos{
    width: 50%;
    height: 80%;
    background-color: #f1f1f1;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left:0;
    right:0;
    border:2px solid #bdbdbd;
    top: 60px;
    display: none;


}


#plan{
    width: 50%;
    height: 80%;
    background-color: #f1f1f1;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left:0;
    right:0;
    border:2px solid #bdbdbd;
    top: 60px;
    display: none;


}


#vigencia{
    width: 50%;
    height: 80%;
    background-color: #f1f1f1;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left:0;
    right:0;
    border:2px solid #bdbdbd;
    top: 60px;
    display: none;


}


#inicio{
    width: 50%;
    height: 80%;
    background-color: #f1f1f1;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left:0;
    right:0;
    border:2px solid #bdbdbd;
    top: 60px;
    display: none;


}

#operacion_m{
    width: 50%;
    height: 80%;
    background-color: #f1f1f1;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left:0;
    right:0;
    border:2px solid #bdbdbd;
    top: 60px;
    display: none;


}

#adj{
    padding: 20px;
}



.fila-no-distribuido {
    /* color: red; */
    /* text-shadow: rgba(255, 0, 0, 0.603) 0px 0px 1px; */
    background: radial-gradient(#ff00001a, transparent 91%);
}



.select2-container {
    box-sizing: border-box;
    display: inline-block;
    margin: 0;
    position: relative;
    vertical-align: middle;
    width: 500px !important;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
    color: #444;
    line-height: 14px !important;
}

</style>
